<template>
	<div>
		<div class="welcome-login text-center">
			<!-- display the district info -->
            <img v-if="logoSrc" :src="logoSrc" :alt="districtName + ' logo'"/>
            <h3 class="district-name">{{ districtName }}</h3>
			<hr/>
            <h3 class="mb-10">{{ title }}</h3>
						<h3 v-if="subtitle.length" class="district-name mb-15">{{subtitle}}</h3>
						<div class="user-profile-wrap panel" v-if="!!user.first_name">
							<div class="panel-body">
								<div class="col-md-2"><font-awesome-icon icon="user" size="3x"></font-awesome-icon></div>
								<div class="col-md-10">
									<p><i>{{user.first_name}} {{user.last_name}} ({{user.friendly_id}}) <br/> {{user.email}}</i></p>
								</div>
							</div>
						</div>
            <!-- display any messages ( allowing html formatting ) -->
            <div v-if="getActiveMessage"
            	id="formFeedback"
            	:class="getMessageClass"
                v-html="getActiveMessage.content">
            </div>

			<div class="" v-if="!!mainButtonLink">
                <a 
					:href="secureButtonLink"
              		type="submit"
                	class="btn btn-block btn-primary">
                    {{mainButtonText}}
                </a>
            </div>
        </div>

        <div class="go-back" v-if="!!entrypoint">
            <a :href="entrypoint"><i class="fas fa-chevron-left"></i> {{backText}}</a>
        </div>
    </div>
    
</template>
                
<script>
    export default{
    props:{
			clientName: {
				type: String,
				required: false,
				default: "Third Party Site",
			},
			csrfToken: "",
			districtName : "",
			backText: {
				default: "Go Back"
			},
            logoSrc : "",
            loginText : {
                type: String
            },
        	message : {
        		type: Object,
				default: function(){
					return {
						category: "info",
						content: "Please enter the following:"
					}
				}
			},
			title: {
					type: String,
					default : "Notification"
			},
			subtitle: {
					type: String,
					default : ""
			},
			user: {
				type: Object,
				default: function(){
					return {}
				}
			},
			entrypoint : {
				type: String,
				required: true
			},
			postEndpoint : {
				type: String,
				required: true
			},
			mainButtonLink : {
				type: String,
			},
			mainButtonText : {
				type: String,
            },
            showPin : {
                type : Boolean,
                default : false
            },
            showEmail : {
                type : Boolean,
                default : true
            },
            showUsername : {
                type : Boolean,
                default : false
            },
						trustedClientFlg: {
							type: String,
							required: false,
							default:"N"
						},
        },
        data(){
            return{
            	username: "",
                password: "",
                email: "",
                pin: ""
            }
        },
        computed: {
			isTrustedClient(){
				return this.trustedClientFlg == 'Y';
			},
			secureButtonLink(){
				let secureLink = this.mainButtonLink;
				if( !!this.csrfToken ){
					secureLink += '&_csrfToken=' + this.csrfToken;
				} 
				return secureLink;
			},
    		isFormInvalid() {
      			return Object.keys( this.fields ).some( key => this.fields[ key ].invalid );
    		},
    		isFormTouched() {
    			return Object.keys( this.fields ).some( key => this.fields[ key ].touched );
    		},
    		getMessageClass() {
    			return "text-left alert alert-" + this.getActiveMessage.category;
    		},
    		getActiveMessage() {
    			if( this.isFormInvalid && this.isFormTouched ){
    				return {
    					category : "warning",
    					content : "Some required fields are missing!"
    				}
    			} else{
    				return this.message;
    			}
    		}

  		},
        methods: {
            validateBeforeSubmit() {
                this.$validator.validateAll().then((result) => {
	                if (result) {
	                    this.$refs.form.submit();
	                    return;
	                }

	                            	});
            }
        }  
    }
</script>